import {Button, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import InfoModal from '../../BookingTool/InfoModal';
import {getCopy} from '../../../utils/getCopy';


const useStyles = makeStyles((theme: Theme) => ({
  linkButton: {},
}));

const HowToUseSite = (props: { className?: string }) => {
  const {className,...rest} = props;
  const classes = useStyles();

  const [openModal, setModal] = React.useState(false);
  const content = getCopy('how-to-use-site');

  return (
      <React.Fragment>
          <Button onClick={() => setModal(true)} variant="contained" className={classes.linkButton}>How to use the site</Button>
          {openModal && (
              <InfoModal onClose={() => setModal(false)} open={true} title="How To Use The Site" body={content}/>
          )}
      </React.Fragment>
  );
};

export default HowToUseSite;
